/* ==========================================================================
   POLITA AUTOGRU — cursor.js
   Cursore personalizzato: punto preciso + anello con inseguimento fluido (lerp).
   Si attiva solo su pointer fine (mouse), si disattiva con prefers-reduced-motion.
   Vanilla JS, nessuna dipendenza.
   ========================================================================== */
(function () {
  'use strict';

  /* Solo dispositivi con mouse reale e movimento consentito. */
  var fine = window.matchMedia('(pointer: fine)').matches;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!fine || reduce) return;

  var root = document.documentElement;
  root.classList.add('has-custom-cursor');

  /* Elementi: anello (insegue) + punto (preciso). */
  var ring = document.createElement('div');
  ring.className = 'cursor cursor--ring';
  var dot = document.createElement('div');
  dot.className = 'cursor cursor--dot';
  document.body.appendChild(ring);
  document.body.appendChild(dot);

  /* Posizioni: il punto è immediato, l'anello segue con interpolazione. */
  var mx = window.innerWidth / 2, my = window.innerHeight / 2;
  var rx = mx, ry = my;
  var visible = false;

  /* Selettori considerati "interattivi": l'anello cresce in hover. */
  var INTERACTIVE = 'a, button, [role="button"], input, textarea, select, label, summary, [data-cursor="hover"], .btn, .nav__link';
  /* Sezioni a sfondo scuro: il cursore diventa giallo (su chiaro resta azzurro). */
  var DARK = '.scheme-dark, .scheme-anthracite';

  document.addEventListener('pointermove', function (e) {
    if (e.pointerType !== 'mouse') return;
    mx = e.clientX;
    my = e.clientY;
    if (!visible) {
      visible = true;
      root.classList.add('cursor-active');
    }
    var target = e.target;
    var hot = target.closest ? target.closest(INTERACTIVE) : null;
    root.classList.toggle('cursor-hover', !!hot);
    var onDark = target.closest ? !!target.closest(DARK) : false;
    root.classList.toggle('cursor-on-dark', onDark);
  }, { passive: true });

  /* Press feedback. */
  document.addEventListener('pointerdown', function () { root.classList.add('cursor-down'); }, { passive: true });
  document.addEventListener('pointerup', function () { root.classList.remove('cursor-down'); }, { passive: true });

  /* Nascondi quando il mouse esce dalla finestra. */
  document.addEventListener('mouseleave', function () { root.classList.remove('cursor-active'); visible = false; });
  document.addEventListener('mouseenter', function () { root.classList.add('cursor-active'); visible = true; });
  window.addEventListener('blur', function () { root.classList.remove('cursor-active'); visible = false; });

  /* Loop di rendering: punto preciso, anello con lerp (peso percepito). */
  function render() {
    rx += (mx - rx) * 0.18;
    ry += (my - ry) * 0.18;
    ring.style.transform = 'translate3d(' + rx + 'px,' + ry + 'px,0) translate(-50%,-50%)';
    dot.style.transform = 'translate3d(' + mx + 'px,' + my + 'px,0) translate(-50%,-50%)';
    requestAnimationFrame(render);
  }
  requestAnimationFrame(render);
})();
